<template>
  <CountryPage country="canada" />
</template>